import { Divider, Flex, Text } from "@chakra-ui/react";

import { formatPrice } from "../../utils/format";

type PedidoData = {
	cliente: string;
	date_ano: number;
	date_dia: number;
	date_mes: string;
	date_venda: string;
	des_status: string;
	emp_cod: number;
	id_order: number;
	item_nome: string;
	json_order: string;
	loja: string;
	operacao: string;
	prev_entrega: string;
	prev_tipo: string;
	qtd: number;
	total: number;
	view_status: string;
}
interface PedidoParams {
	pedido: PedidoData;
	setPedidoDrawer: (pedido: PedidoData) => void;
	setIsOpenPedidoDrawer: (open: boolean) => void;
}

const Pedido: React.FC<PedidoParams> = ({
	pedido,
	setPedidoDrawer,
	setIsOpenPedidoDrawer
}) => {
	return (
		<Flex
			flexDir="column"
			borderWidth={1}
			borderColor="gray.100"
			borderRadius={8}
			p="4"
			cursor="pointer"
			_hover={{
				boxShadow: "0 0 4px rgba(0, 0, 0, 0.5)",
				transition: "boxShadow 0.9s",
			}}
			onClick={() => {
				setPedidoDrawer(JSON.parse(pedido.json_order));
				setIsOpenPedidoDrawer(true);
			}}
		>
			<Flex align="center">
				{/* DATA */}
				<Flex flexDir="column" align="center" mr="6">
					<Flex flexDir="column" borderRadius={8}>
						<Text
							bg="blue.100"
							w="100%"
							px="3"
							color="white"
							fontSize="11"
							fontWeight="600"
							align="center"
							borderWidth={1}
							borderColor="blue.100"
							borderTopRightRadius={8}
							borderTopLeftRadius={8}
							textTransform="capitalize"
						>{pedido.date_mes}</Text>
						<Text
							align="center"
							fontSize="18"
							fontWeight="500"
							w="100%"
							py="1.5"
							borderLeftWidth={1}
							borderRightWidth={1}
							borderBottomWidth={1}
							borderBottomRightRadius={8}
							borderBottomLeftRadius={8}
							borderColor="gray.100"
						>{pedido.date_dia}</Text>
					</Flex>

					<Text fontSize={13} fontWeight="500" color="gray.700">{pedido.operacao}</Text>
				</Flex>

				{/* DADOS VENDA */}
				<Flex flexDir="column">
					<Text fontWeight="500">{pedido.cliente}</Text>
					<Text fontSize={14} fontWeight="500" color="gray.700">{pedido.loja}</Text>
					<Text fontSize={14} fontWeight="500" color="gray.700">{pedido.des_status}</Text>

					<Flex>
						<Text fontSize={13} fontWeight="500" color="gray.400" pr="2">
							Total: {formatPrice(pedido.total)}
						</Text>
						<Text fontSize={13} fontWeight="500" color="gray.400">-&nbsp; Ano: {pedido.date_ano}</Text>
					</Flex>
				</Flex>
			</Flex>

			<Divider my="2" />

			<Flex>
				<Text fontSize={13} fontWeight="500" color="gray.400" pr="2">{pedido.prev_tipo}:</Text>
				<Text fontSize={13} fontWeight="500" color="gray.400">{pedido.prev_entrega}</Text>
			</Flex>
		</Flex>
	)
}

export default Pedido;